import * as React from "react";
const SvgFiRrLeadership = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-leadership_svg__a)">
      <path
        fill="#062147"
        d="M1 7.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M14.5 5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m9.355 8.981a1 1 0 0 1-.336 1.373l-14 8.5a1 1 0 0 1-.52.146H8a1 1 0 0 1-1-1v-3H3v1.5c0 .197-.058.391-.167.555l-1 1.5a1 1 0 1 1-1.664-1.11L1 21.197V14c0-1.24.745-2.336 1.898-2.791.057-.022 5.405-1.076 5.405-1.076a1 1 0 0 0 .503-.264l3.013-2.916A2.99 2.99 0 0 1 13.999 6h5V1.296A1.296 1.296 0 0 1 20.963.184l2.627 1.573a.877.877 0 0 1 0 1.487L21 4.511v2.49a1 1 0 0 1-1 1h-3v5c1.103 0 2 .897 2 2v.759l3.48-2.113a1 1 0 0 1 1.375.336zM5 12.818l-1.437.282A1 1 0 0 0 3 14v4h2zm6-2.29-.801.777c-.418.406-.941.68-1.512.791L7 12.427v5.574c1.103 0 2 .897 2 2v1.83l2-1.214zM13 13h2V8h-1c-.551 0-1 .448-1 1zm4 2h-4v4.402l4-2.429z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-leadership_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLeadership;
